import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import { BodyText, EyebrowText, LabelText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import { useMemo } from 'react';
import { CALLIE_LEARN_MORE_HELP_URL } from 'components/home/ai_assistant_banner/constants';
const sidebarInnerCss = "sryjk0b";
const stepListCss = "s1gtc1ac";
const stepCss = "s1prl5l9";
const stepRailCss = "s13ot8lh";
const stepConnectorCss = "s1au8yc";
const stepCopyCss = "stkw7do";
const buildHowToSteps = () => [{
  title: I18n.t('publisher.home.scheduling_subsection.callie.card.how_to.step_1_title'),
  body: I18n.t('publisher.home.scheduling_subsection.callie.card.how_to.step_1_body')
}, {
  title: I18n.t('publisher.home.scheduling_subsection.callie.card.how_to.step_2_title'),
  body: I18n.t('publisher.home.scheduling_subsection.callie.card.how_to.step_2_body')
}, {
  title: I18n.t('publisher.home.scheduling_subsection.callie.card.how_to.step_3_title'),
  body: I18n.t('publisher.home.scheduling_subsection.callie.card.how_to.step_3_body')
}];
export const CallieHowToUsePrompts = () => {
  const howToSteps = useMemo(buildHowToSteps, []);
  return <aside className={sidebarInnerCss} data-testid="callie-how-to">
      <EyebrowText color={colorTextSecondary} size="small">
        {I18n.t('publisher.home.scheduling_subsection.callie.card.how_to.heading')}
      </EyebrowText>
      <ol className={stepListCss}>
        {howToSteps.map(({
        body,
        title
      }, index) => <li key={title} className={stepCss}>
            <div className={stepRailCss}>
              <LabelText color={colorTextSecondary} size="medium" weight="semibold">
                {index + 1}
              </LabelText>
              {index < howToSteps.length - 1 && <span aria-hidden className={stepConnectorCss} />}
            </div>
            <div className={stepCopyCss}>
              <BodyText color="muted" size="small" weight="semibold">
                {title}
              </BodyText>
              <BodyText color="muted" size="small">
                {body}
              </BodyText>
            </div>
          </li>)}
      </ol>
      <BodyText color="muted" size="small">
        {I18n.t('publisher.home.scheduling_subsection.callie.card.how_to.still_need_help')}
        {' '}
        <Link href={CALLIE_LEARN_MORE_HELP_URL} rel="noopener noreferrer" target="_blank" variant="subtle">
          {I18n.t('publisher.home.scheduling_subsection.callie.card.how_to.learn_more')}
        </Link>
      </BodyText>
    </aside>;
};

require("./how_to_prompts.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./how_to_prompts.js");